import React from "react";
import { StyledBioSection } from "./styles";
import { TerminalIcon } from "@components/Icons";

/* @ts-ignore:disable-next-line */
import selfImage from "@images/self.png";

const TECHNOLOGIES = [
  "JavaScript (ES6+)",
  "HTML, CSS",
  "React",
  "Node.js",
  "Next.js",
  "React Native",
];

const BioSection = ({ ...props }) => {
  return (
    <StyledBioSection {...props}>
      <div className="content">
        <div className="info">
          <h2 className="heading">A little bit about me.</h2>
          <p className="paragraph">
            I’m a front-end developer based in Vancouver, Canada. I have a
            strong 🔥 passion for building 🕸️ web and 📱 mobile applications. I
            enjoy learning and experimenting with new technology.
          </p>
          <p className="paragraph">
            Aside from programming, I enjoy, as you may have guessed, playing{" "}
            <span>🏸 badminton</span>.
          </p>
          <div className="terminal">
            <div className="terminal-head">
              <span className="dot dot-1" />
              <span className="dot dot-2" />
              <span className="dot dot-3" />
              <div className="name">
                <TerminalIcon color="rgb(121, 181, 213)" size={18} />
                <span>Technologies -- recently used</span>
              </div>
            </div>
            <div className="terminal-content">
              {TECHNOLOGIES.map((tech, index) => (
                <span key={`tech-${index}`}>{tech}</span>
              ))}
            </div>
          </div>
        </div>
        <div className="photo">
          <img src={selfImage} alt="Jason Photo" />
        </div>
      </div>
    </StyledBioSection>
  );
};

export default BioSection;
